import { render, staticRenderFns } from "./WalletExtractStatisticsCard.vue?vue&type=template&id=37b2280e&scoped=true"
import script from "./WalletExtractStatisticsCard.vue?vue&type=script&lang=js"
export * from "./WalletExtractStatisticsCard.vue?vue&type=script&lang=js"
import style0 from "./WalletExtractStatisticsCard.vue?vue&type=style&index=0&id=37b2280e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b2280e",
  null
  
)

export default component.exports